module.exports = "<div fxLayout=\"column\">\n    <app-header class=\"header-alignment\"></app-header>\n    <router-outlet></router-outlet>\n  <app-footer class=\"footer-align\"></app-footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/master/master.component.html
// module id = ./src/app/components/master/master.component.html
// module chunks = main